/**
 * @flow
 * @relayHash f9a095f0767f3e42b07e175dd0cc3f74
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type login_MutationVariables = {|
  input: {
    id_token: string,
    clientMutationId?: ?string,
  },
|};
export type login_MutationResponse = {|
  +login: ?{|
    +profile: ?{|
      +id: string,
      +user_id: string,
      +email: ?string,
      +external_provider: ?string,
      +first_name: ?string,
      +is_new_user: boolean,
      +ga_account_goal_sent: boolean,
      +last_name: ?string,
      +picture: ?string,
      +company_name: ?string,
      +company_size: ?{|
        +name: ?string,
      |},
      +industry: ?{|
        +name: ?string,
      |},
      +job_type: ?{|
        +name: ?string,
      |},
    |},
    +cart: ?{|
      +id: string,
      +license_line_items: ?$ReadOnlyArray<?{|
        +id: string,
      |}>,
    |},
  |},
|};
*/


/*
mutation login_Mutation(
  $input: LoginInput!
) {
  login(input: $input) {
    profile {
      id
      user_id
      email
      external_provider
      first_name
      is_new_user
      ga_account_goal_sent
      last_name
      picture
      company_name
      company_size {
        name
        id
      }
      industry {
        name
        id
      }
      job_type {
        name
        id
      }
    }
    cart {
      id
      license_line_items {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "LoginInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "LoginInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ga_account_goal_sent",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "external_provider",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "first_name",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "is_new_user",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "user_id",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "last_name",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "picture",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "company_name",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v13 = [
  v12
],
v14 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "cart",
  "storageKey": null,
  "args": null,
  "concreteType": "Cart",
  "plural": false,
  "selections": [
    v3,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "license_line_items",
      "storageKey": null,
      "args": null,
      "concreteType": "LicenseLineItem",
      "plural": true,
      "selections": [
        v3
      ]
    }
  ]
},
v15 = [
  v12,
  v3
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "login_Mutation",
  "id": null,
  "text": "mutation login_Mutation(\n  $input: LoginInput!\n) {\n  login(input: $input) {\n    profile {\n      id\n      user_id\n      email\n      external_provider\n      first_name\n      is_new_user\n      ga_account_goal_sent\n      last_name\n      picture\n      company_name\n      company_size {\n        name\n        id\n      }\n      industry {\n        name\n        id\n      }\n      job_type {\n        name\n        id\n      }\n    }\n    cart {\n      id\n      license_line_items {\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "login_Mutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "login",
        "storageKey": null,
        "args": v1,
        "concreteType": "LoginPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "profile",
            "storageKey": null,
            "args": null,
            "concreteType": "Profile",
            "plural": false,
            "selections": [
              v2,
              v3,
              v4,
              v5,
              v6,
              v7,
              v8,
              v9,
              v10,
              v11,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "company_size",
                "storageKey": null,
                "args": null,
                "concreteType": "CompanySize",
                "plural": false,
                "selections": v13
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "industry",
                "storageKey": null,
                "args": null,
                "concreteType": "Industry",
                "plural": false,
                "selections": v13
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "job_type",
                "storageKey": null,
                "args": null,
                "concreteType": "JobType",
                "plural": false,
                "selections": v13
              }
            ]
          },
          v14
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "login_Mutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "login",
        "storageKey": null,
        "args": v1,
        "concreteType": "LoginPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "profile",
            "storageKey": null,
            "args": null,
            "concreteType": "Profile",
            "plural": false,
            "selections": [
              v2,
              v3,
              v4,
              v5,
              v6,
              v7,
              v8,
              v9,
              v10,
              v11,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "company_size",
                "storageKey": null,
                "args": null,
                "concreteType": "CompanySize",
                "plural": false,
                "selections": v15
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "industry",
                "storageKey": null,
                "args": null,
                "concreteType": "Industry",
                "plural": false,
                "selections": v15
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "job_type",
                "storageKey": null,
                "args": null,
                "concreteType": "JobType",
                "plural": false,
                "selections": v15
              }
            ]
          },
          v14
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = 'dc91de9249b719734b5255792394d8ee';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/login_Mutation.graphql.js